import React, { useContext } from 'react'
import { Close } from '@mui/icons-material'
import { useHistory } from 'react-router-dom'
import globalContext from '../../context/global/globalContext'
import { analyticsEvent } from '../../controller/BaseTool'
import { WtString } from '../../constants/strings'
import { WtAnalytic } from '../../constants/analyticsKeys'
import { getLoggedUserInfo } from '../../basetool/methods'
import { WtLoginKey } from '../../constants/loginKeys'
import { Slide } from '@mui/material'


export const OutsideOfferUI = () => {
    const offerImg = useContext(globalContext)
    const setOfferImg = useContext(globalContext)
    const offerImgUrl = useContext(globalContext)
    const history = useHistory()
    const openURL = (url) => {
        analyticsEvent(getLoggedUserInfo(WtLoginKey.userName) ? getLoggedUserInfo(WtLoginKey.userName) : WtString.nonLoggedInUserText, WtAnalytic.topFullWidthOfferBannerClicked, window.location.search)
        history.push(url)
    }

    return (
        <Slide direction="down" in={true} timeout={1000} unmountOnExit>
            <div>
                {
                    offerImg.offerImg &&
                    <>
                        <Close onClick={() => setOfferImg.setOfferImg(false)} className="hand" style={{ position: 'absolute', right: '10px', top: '10px', color: '#fff' }} />
                        <img onClick={() => openURL('/pricing')} src={offerImgUrl.offerImgUrl} className="img-fluid w-100 d-block hand" alt={WtString.SiteName} />
                    </>

                }
            </div>
        </Slide>
    )
}
